import FormLabel from './label';

export default FormLabel;
